import React from 'react'
import { URL_CTRL_HIDRIC } from '../../router/Url'

export const MedidoresUniverse = () => {
    return new Promise(async (resolve, reject) => {
        let query = await fetch(URL_CTRL_HIDRIC+'allmedidorsuniverse',{
            method: 'POST',
            headers: {
                'authorization': "paico2021",
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            // body: JSON.stringify({
            // })
        })
        let responsito = await query.json();
        // console.log(responsito)

        if(responsito.success){
            resolve(responsito.body)
        }else{
            resolve([])
        }
    })
}
